import React from "react";
import { useTranslation } from "react-i18next";
import { status as statusMock } from "@planzone/dto";
import { ColorPicker } from "@common/colorPicker";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import { ColorPickerIcon } from "./colorPickerIcon";
import styles from "./styles.scss";

function Form({ submit }: Props) {
  const { t } = useTranslation();
  const [status, setStatus] = React.useState(statusMock);
  const [isIncludingCompletion, setIsIncludingCompletion] =
    React.useState(false);

  return (
    <div className={styles.form}>
      <div className={styles.row}>
        <VisibilitySwitch
          renderChildren={(isVisible, show, hide) => (
            <div className={styles.wrapper}>
              <div onClick={isVisible ? hide : show} className={styles.iconBox}>
                {status.color ? (
                  <div
                    className={styles.icon}
                    style={{ backgroundColor: status.color }}
                  />
                ) : (
                  <ColorPickerIcon className={styles.icon} />
                )}
              </div>
              {isVisible && (
                <div className={styles.colorPicker}>
                  <ColorPicker
                    color={status.color}
                    pick={(color) => setStatus({ ...status, color })}
                  />
                </div>
              )}
            </div>
          )}
        />
        <input
          className={styles.input}
          value={status.label}
          placeholder={t("statusCreationForm.namePlaceholder")}
          onChange={({ target }) =>
            setStatus({
              ...status,
              label: target.value,
            })
          }
          onKeyUp={({ key }) => key === "Enter" && submit(status)}
          autoFocus
        />
        <button className={styles.button} onClick={() => submit(status)}>
          {t("statusCreationForm.submit")}
        </button>
      </div>
      <div className={styles.row}>
        <div
          className={styles.row}
          onClick={() => setIsIncludingCompletion(!isIncludingCompletion)}
        >
          <Checkbox isChecked={isIncludingCompletion} />
          <p className={styles.label}>{t("statusCreationForm.label")}</p>
        </div>
        {isIncludingCompletion && (
          <input
            className={styles.completionInput}
            value={status.percentComplete}
            type="number"
            placeholder={"%"}
            onChange={({ target }) =>
              target.value !== ""
                ? parseInt(target.value) >= 0 &&
                  parseInt(target.value) <= 99 &&
                  setStatus({
                    ...status,
                    percentComplete: parseInt(target.value),
                  })
                : setStatus({
                    ...status,
                    percentComplete: undefined,
                  })
            }
            onKeyUp={({ key }) => key === "Enter" && submit(status)}
          />
        )}
      </div>
      {isIncludingCompletion && (
        <div className={styles.row}>
          <p className={styles.warning}>{t("statusCreationForm.warning")}</p>
        </div>
      )}
    </div>
  );
}

export { Form };
